import type { SVGProps } from 'react';

const ConfigIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 36 36"
      fill="currentColor"
      {...props}
    >
      <path d="M13.8984 14C15.0027 14.0001 15.8984 14.727 15.8984 15.623V20.377L15.8877 20.543C15.7853 21.361 14.9337 21.9999 13.8984 22C12.8631 22 12.0106 21.3611 11.9082 20.543L11.8984 20.377V15.623C11.8984 14.727 12.7941 14 13.8984 14ZM9.89844 19.3662H4.7998V16.6348H9.89844V19.3662ZM31.2002 19.3662H17.8984V16.6348H31.2002V19.3662Z" />
      <path d="M22.1016 12C20.9973 11.9999 20.1016 11.273 20.1016 10.377L20.1016 5.62305L20.1123 5.45703C20.2147 4.63898 21.0663 4.0001 22.1016 4C23.1369 4 23.9894 4.63891 24.0918 5.45703L24.1016 5.62305L24.1016 10.377C24.1016 11.273 23.2059 12 22.1016 12ZM26.1016 6.63379L31.2002 6.63379L31.2002 9.36523L26.1016 9.36523L26.1016 6.63379ZM4.79981 6.63379L18.1016 6.63379L18.1016 9.36523L4.7998 9.36523L4.79981 6.63379Z" />
      <path d="M19.8984 24C21.0027 24.0001 21.8984 24.727 21.8984 25.623V30.377L21.8877 30.543C21.7853 31.361 20.9337 31.9999 19.8984 32C18.8631 32 18.0106 31.3611 17.9082 30.543L17.8984 30.377V25.623C17.8984 24.727 18.7941 24 19.8984 24ZM15.8984 29.3662H4.7998V26.6338H15.8984V29.3662ZM31.2002 29.3662H23.8984V26.6338H31.2002V29.3662Z" />
    </svg>
  );
};

export default ConfigIcon;
